import React, { useState, useRef, useEffect } from "react";
import { useAuth } from '../helpers/authContext'; 
import { Link } from "react-router-dom";import { isLoggedWithKeychain, steemCustomApi } from "services/dsteem-service";
import { getTimeAgo } from "services/posts-service";
import { markAsReadWithWif } from "helpers/steem";
import { markAsReadKeychain } from "helpers/keychain";
import { get_db_notifications } from "services/db-service";

const NotificationsDropdown = ({ }) => {
    const {user, autologin, notifications_viewed, updateNotificationsViewed } = useAuth();
    const [open, setOpen] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const [marking, setIsMarking] = useState(false);
    const [unread, setUnread] = useState(0);
    const [lastread, setLastread] = useState("");
    const [localNotifications, setLocalNotifications] = useState([]);
    const [systemNotifications, setSystemNotifications] = useState([]);
    const menuRef = useRef<HTMLDivElement | null>(null); 
    let keychainLogin = isLoggedWithKeychain(autologin); 
    async function getUserNotifications () {
        if (user) {
            try {
                let params = {
                    account:user,
                    limit:50
                }
                let notifications, system_notifications, unread_notifications;
                try {
                    notifications = await steemCustomApi("bridge.account_notifications", params);
                    system_notifications = await get_db_notifications();
                    unread_notifications = await steemCustomApi("bridge.unread_notifications", [user]);
                } catch (error) {
                    console.log("while getting notifications", error); 
                    return;
                } 
                let unread_system_notifications = system_notifications.filter((n) => !notifications_viewed.includes(n.id)); 
                
                let number = ((unread_notifications && unread_notifications.unread)? unread_notifications.unread:0)+unread_system_notifications.length;
                setUnread(number);
                setLastread((unread_notifications && unread_notifications.lastread)?unread_notifications.lastread : "");
                setLocalNotifications((notifications && notifications.length > 0)?notifications:[]); 
                setSystemNotifications((system_notifications && system_notifications.length > 0)?system_notifications:[]); 

                // console.log(system_notifications); 
            } catch (error) {
                console.log("Failed getting notifications", error);
                
            }
        }
    }
    const handleRefreshNotifications = async () => { 
        setIsMarking(true);
        await getUserNotifications();
        setIsMarking(false);
    }
    const handleMarkAsRead = async () => { 
        setIsMarking(true);
    
        const markFn = keychainLogin ? markAsReadKeychain : markAsReadWithWif;
        const account = keychainLogin ? user : autologin;
    
        try {
            let timeNow = new Date().toISOString().slice(0, 19); 
            
            const result:any = await markFn(account, timeNow);
        
            if (!result.success) {
                console.log(result.result?.message || "Error marking as read.");
                setIsMarking(false);
                return;
            } 
            setUnread(0);
            setLastread(timeNow);
            setTimeout(async () => {
                await getUserNotifications();
            }, 3000);
          
          
        } catch (error) { 
          console.log("Error voting: " + error.message);
        }
        setIsMarking(false);
    }; 
    useEffect(() => {
        if (!user) return;
    
        let mounted = true;
        const run = async () => { 
          await getUserNotifications();
        };
        run();
    
        const refresh_interval = setInterval(() => {
            console.log("Getting new notifications...");
            
            if (mounted) getUserNotifications();
        }, 60000);
    
        return () => {
          mounted = false;
          clearInterval(refresh_interval);
        };
    }, [user]);

    useEffect(() => {
      const handleClickOutside = (event) => {
        const menuNode = menuRef.current;
        if (menuNode && !menuNode.contains(event.target)) {
            handleClose();
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleToggle = () => {
        if (open) {
            handleClose();
        } else {
            setOpen(true);
        }
    };

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            setOpen(false);
            setIsClosing(false);
        }, 300); // match animation duration
    };
    const handleSystemNotificationClick = (notification) => {
        const id = notification.id;
        if (!notifications_viewed.includes(id)) {
            const updated = [...notifications_viewed, id];
            updateNotificationsViewed(updated);   
        }
    }; 
    function renderNotification(n: any, id, system = false) {
        let temp = n.msg.split(' ');
        let account = temp[0];
        const unRead = !system
            ? Date.parse(`${lastread}Z`) <= Date.parse(`${n.date}Z`)
            : !notifications_viewed.includes(n.id); 

        let imageLink =
            account.indexOf("@") !== -1
                ? `https://steemitimages.com/u/${account.replace("@", "")}/avatar`
                : `/assets/img/setting.png`;

        const handleClick = () => {
            if (system) {
                handleSystemNotificationClick(n);
            }
            handleClose();
        };

        return (
            <li key={id} className={"dropdown-menu-item " + (unRead ? "" : "opened")}>
                <Link to={account.replace("@", "/u/")} onClick={handleClose}>
                    <img src={imageLink} alt="" className="notification-profile-icon" />
                </Link>
                <div className="d-inline-block">
                    <Link
                        to={n.url.replace("@", "/p/")}
                        onClick={handleClick}
                    >
                        {n.msg.replace("resteemed", "shared")}
                    </Link>
                    <span className="notification-time text-muted">
                        {getTimeAgo(system ? n.created : n.date)} <i className={`fas fa-circle ${(unRead ? "unread" : "readed")}`} />
                    </span>
                </div>
            </li>
        );
    }


    return (
      <div ref={menuRef} className="relative inline-block text-left">
        <button
          className="collapse-item user-logo-button"
          onClick={handleToggle}
        >
          <span>
            <i className="fas fa-bell notification-icon" />
          </span> 
          {unread > 0 && (
            <span className="notification-number">
                {(unread>99)? '+99' : unread}
            </span>
          )} 
        </button>

        {open && (
          <div className={`absolute dropdown-menu-notifications ${isClosing ? 'dropdown-animate-out' : 'dropdown-animate-in'}`} style={{maxHeight:'500px', overflow:'auto'}}>
              <ul className="nav">
                  <li className="dd-header dropdown-menu-item ">
                      <b>NOTIFICATIONS</b>
                      <div className="inline-block text-muted">
                        <span className="d-inline-block mr-4 mark-as-read" onClick={handleRefreshNotifications}>
                            <i className="fas fa-rotate-right"></i>
                        </span>
                        <span className="d-inline-block mark-as-read" onClick={handleMarkAsRead}>
                            <i className="fas fa-check"></i>
                        </span>
                      </div> 
                  </li> 
                  {(systemNotifications && systemNotifications.length > 0) && (
                    <>
                        <li className="dropdown-menu-item sep">
                            <b>System</b>  
                        </li>
                        {systemNotifications.map((n, id) => renderNotification(n, id, true))} 
                    </>
                  )} 
                  <li className="dropdown-menu-item sep">
                      <b>Account</b>  
                  </li>
                  {marking && <li className="text-center d-block dropdown-menu-item"><span className="spinner dark small" /></li> }
                  {(localNotifications && localNotifications.length > 0) ? localNotifications.map((n, id) => renderNotification(n, id)): <span>You are up to date.</span>}
              </ul> 
          </div>
        )}
      </div>
    );
};

export default NotificationsDropdown;
